import { FactorAnalsysisBackend } from "./analysis.model";

const apiBaseUrl = process.env.REACT_APP_API_ANALYSIS_URIBASE!;

export interface IAnalysisService {
	fetchFactor(ticker: string, currency: string): Promise<FactorAnalsysisBackend | null>;
}

export class AnalysisServiceImpl implements IAnalysisService {
	async fetchFactor(ticker: string, currency: string): Promise<FactorAnalsysisBackend | null> {
		const response = await fetch(`${apiBaseUrl}/${ticker}/factor/${currency}`);
		const responseJson = await response.json();
		if (responseJson) {
			responseJson.updatedAt = new Date(Date.parse(responseJson.updatedAt))
		}

		return responseJson;
	}
}